export const getBadgeDetailsAndIconColorForCareTag = (
  regimenTag: string,
): {
  badgeText: string;
  iconColor: string;
  badgeBgColor: string;
  badgeTextColor: string;
  borderColor: string;
} => {
  if (regimenTag === "Continuation of care") {
    return {
      badgeText: "Continuation of care",
      iconColor: "#008367",
      badgeBgColor: "#E6F3F0",
      badgeTextColor: "#1F1F1F",
      borderColor: "#008367",
    };
  }

  if (regimenTag === "Initial line") {
    return {
      badgeText: "New line of care",
      iconColor: "#C24400",
      badgeBgColor: "#FFF3E0",
      badgeTextColor: "#1F1F1F",
      borderColor: "#C24400",
    };
  }

  return {
    badgeText: regimenTag,
    iconColor: "#000000",
    badgeBgColor: "#F5F5F5",
    badgeTextColor: "#000000",
    borderColor: "#000000",
  };
};
